import { render, staticRenderFns } from "./Iteminfo.vue?vue&type=template&id=4cd1ab22&scoped=true&"
import script from "./Iteminfo.vue?vue&type=script&lang=js&"
export * from "./Iteminfo.vue?vue&type=script&lang=js&"
import style0 from "./Iteminfo.vue?vue&type=style&index=0&id=4cd1ab22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd1ab22",
  null
  
)

export default component.exports